import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {SessionStore} from "../../core/stores/session/session.store";
import {SessionQuery} from "../../core/stores/session/session.query";
import {ANALYTICS_ACTION, ANALYTICS_TYPE} from "../../core/interfaces/analytics";
import {AuthService} from "../login/login.service";

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    selector: 'metadv-login-confirmation',
    templateUrl: './login-confirmation.component.html',
    styleUrls: ['./login-confirmation.component.css'],
    standalone: false
})
export class LoginConfirmationComponent implements OnInit{

  loading = true;
  errorString = '';

  constructor(
    private _router: Router,
    private _session: SessionStore,
    private _sessionQuery: SessionQuery,
    private _route: ActivatedRoute,
    private _authService: AuthService,
  ) {
  }

  ngOnInit() {
    const code = this._route.snapshot.queryParamMap.get('code');

    if (!code || code === 'null') {
      this.errorString = 'Accesso non autorizzato.';
      this.loading = false;
      return;
    }

    this._authService.exchangeAuthCode(code).subscribe({
      next: (res) => {
        // Salva entrambi i token
        this._session.setTokens(res.accessToken, res.refreshToken);

        this._sessionQuery.sendPendingAnalytics(ANALYTICS_TYPE.LOGIN, ANALYTICS_ACTION.ACCESS);
        this._router.navigate(['/']);
      },
      error: () => {
        this.errorString = 'Codice di accesso non valido o scaduto.';
        this.loading = false;
      }
    });
  }

}
